const headerEl = document.querySelector('.header') || {}; // if any sections with no header.
const navIcon = headerEl.querySelector('.header__hamburger');
const navMobile = headerEl.querySelector('.header__mobile-nav');
const headerNav = headerEl.querySelector('.header__navigation') || {};
// search will be undefined if suppressSearch is true from clubs.json
const search = headerEl.querySelector('.header__search');
const secondaryNav = headerNav.querySelector('.header__nav-items--secondary') || {};
const searchInput = (search && search.querySelector('.header__search-bar')) || {};
const suggestions = (search && search.querySelector('.search__suggestions')) || {};

// no scroll and overlay on body
const toggleNoScroll = () => {
    const mainContent = document.getElementsByTagName('main');
    document.body.classList.toggle('no-scroll');

    if (mainContent.length) {
        mainContent[0].classList.toggle('disabled');
    }
};

const closeSearch = () => {
    if (navIcon.offsetParent !== null) {
        toggleNoScroll();
    }
    search.classList.remove('open');
    searchInput.value = '';
    suggestions.innerHTML = '';
    // mobileNav.style.height = '';
    secondaryNav.classList.remove('expand');
};

// hamburger menu
const toggleMobileMenu = () => {
    toggleNoScroll();
    if (search && search.classList.contains('open')) {
        closeSearch();
    }
    headerEl.classList.toggle('open');
    navIcon.classList.toggle('open');
    navMobile.classList.toggle('open');

    const currentActive = navMobile.querySelector('.active');
    if (currentActive) {
        currentActive.classList.remove('active');
        navMobile.classList.remove('active');
    }
};

module.exports = {
    toggleNoScroll,
    toggleMobileMenu,
    closeSearch
};
